import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "w-full"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "w-1"
})], -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  class: "w-6 text-right"
}, null, -1);
const _hoisted_4 = {
  class: "w-full"
};
const _hoisted_5 = {
  class: "text-right"
};
const _hoisted_6 = {
  class: "text-right"
};
const _hoisted_7 = {
  class: "text-right"
};
const _hoisted_8 = {
  class: "text-right"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, null, -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, null, -1);
const _hoisted_11 = {
  class: "text-right"
};
import TableRow from "@/modules/competitions/components/divisions/Table/TableRow.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'LeagueTable',
  props: {
    division: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("table", _hoisted_1, [_createElementVNode("tr", null, [_hoisted_2, _hoisted_3, _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('team')), 1), _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('matches_short')), 1), _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('wins_short')), 1), _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('draws_short')), 1), _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('loses_short')), 1), _hoisted_9, _hoisted_10, _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('points_short')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collect(__props.division.stats).sortBy('rank'), (stat, i) => {
        return _openBlock(), _createBlock(TableRow, {
          key: stat.id,
          index: i,
          stat: stat,
          promotions: __props.division.promotions,
          relegated: __props.division.relegatedIds.includes(stat.team.id),
          promoted: __props.division.promotedIds.includes(stat.team.id),
          winner: __props.division.competition.winnerId === stat.team.id
        }, null, 8, ["index", "stat", "promotions", "relegated", "promoted", "winner"]);
      }), 128))]);
    };
  }
});